import React, { useState } from "react";
import { FiMail, FiPhoneCall } from "react-icons/fi";
// import { AiOutlineClose } from "react-icons/ai";
import {
  FaYoutube,
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(
        "https://server.premium24.in/api/contactUs",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            contactNo: formData.contact,
            email: formData.email,
            message: formData.message,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSubmitStatus({
          type: "success",
          message: data.message || "Form submitted successfully",
        });
        setFormData({ name: "", contact: "", email: "", message: "" });
      } else {
        setSubmitStatus({
          type: "error",
          message: data.error || "Failed to send message",
        });
      }
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message: "Network error. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className=" px-8 py-12">
      <div className="max-w-90vw mx-auto">
        <h1 className="text-3xl font-bold sm:text-5xl leading-[61px] mt-8 text-gray-800 mb-8">
          Get in Touch with us
        </h1>
        <div className="grid md:grid-cols-2 gap-12">
          <div className="bg-white p-3 rounded-lg shadow-lg">
            {submitStatus && (
              <div
                className={`mb-4 p-3 rounded ${
                  submitStatus.type === "success"
                    ? "bg-green-100 text-green-800"
                    : "bg-red-100 text-red-800"
                }`}
              >
                {submitStatus.message}
              </div>
            )}

            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  <span className="font-bold">Name</span>
                </label>
                <input
                  type="text"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="contact"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  <span className="font-bold">Contact</span>
                </label>
                <input
                  type="text"
                  id="contact"
                  value={formData.contact}
                  onChange={handleChange}
                  placeholder="Your contact number"
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  <span className="font-bold">Email</span>
                </label>
                <input
                  type="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your@email.com"
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="message"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  <span className="font-bold">Message</span>
                </label>
                <textarea
                  id="message"
                  rows={5}
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-4 rounded-md transition-colors disabled:bg-green-400"
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

          <div className="border-l-0 md:border-l md:border-gray-200 md:pl-12 border p-2 pt-3 rounded-lg mt-15 bg-white max-h-[254px]">
            <h2 className="text-2xl font-bold text-gray-800 mb-8">
              Contact Information
            </h2>

            <div className="space-y-6">
              <div>
                <div className="flex items-center mb-1">
                  <FiMail className="text-gray-600 mr-2" />
                  <span className="font-bold text-gray-700">Email</span>
                </div>
                <p className="text-gray-600 ml-6">help@surveysiq.com</p>
              </div>

              <div>
                <div className="flex items-center mb-1">
                  <FiPhoneCall className="text-gray-600 mr-2" />
                  <span className="font-bold text-gray-700">
                    +91 7219770092
                  </span>
                </div>
              </div>
              <div>
                <div className="flex gap-4 text-2xl">
                  <a
                    href="https://www.facebook.com/Surveysiq"
                    className="hover:text-gray-300"
                  >
                    <FaFacebookF />
                  </a>
                  {/* <a href="#" className="hover:text-gray-300">
                  <FaTwitter />
                </a> */}
                  <a
                    href="https://www.youtube.com/@surveysiq"
                    className="hover:text-gray-300"
                  >
                    <FaYoutube />
                  </a>
                  <a
                    href="https://www.instagram.com/surveysiqs/"
                    className="hover:text-gray-300"
                  >
                    <FaInstagram />
                  </a>
                  {/* <a href="#" className="hover:text-gray-300">
                    <FaTelegramPlane />
                  </a> */}
                  <a
                    href="https://api.whatsapp.com/send/?phone=917219770092&text"
                    className="hover:text-gray-300"
                  >
                    <FaWhatsapp />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
